import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import DiagramRefProperty from "./DiagramRefProperty";

import ModelDataContextDataPreviewProperty from "./ModelDataContextDataPreviewProperty";

export default class Model extends ObservablePropertyDescriptorObject {

    data = new PropertyDescriptor(null, "数据上下文", "数据", "jsonobject", "#anticon-json-", {
        dirty: true,
        dirtyText: "请使用数据源代替",
        description: "设置 JSON 对象作为部件的数据上下文，然后在部件脚本中使用，以实现自定义逻辑",
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    refs = new PropertyDescriptor([], '部件集', "引用", "diagram-refs", "#anticon--Scenedismissed", {
        description: "让部件能够非常方便地引用其他部件的数据。添加引用后，使用鼠标将部件从“页面结构”拖拽到引用上即可",
        modelTemplate: DiagramRefProperty,
    });

    dataPreview = new PropertyDescriptor(new ModelDataContextDataPreviewProperty(), '数据预览', "数据预览", "propertygrid", "#anticon-xianshiqilan", {
        enabled: false,
        valueTemplate: ModelDataContextDataPreviewProperty,
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            if (p in this)
                this[p].value = opts[p];
            else {
                console.log(p);
            }
        }

        this.defineAllProperties();
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {

        // console.log(name, valNew);

        if (name.startsWith("dataPreview"))
            args.handled = true;
    }

    toString() {
        return "设置";
    }

    hasDataContext() {
        return !!this.data;
    }

    toJsonObject() {
        const o = super.toJsonObject();
        delete o.dataPreview;
        return o;
    }
}
